import { CommonModule, DatePipe, NgOptimizedImage, ViewportScroller } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../../environments/environment';
import { ICONS } from '../../../utils/svg-icons';
import { ViewStorePopupComponent } from '../../popups/view-store-popup/view-store-popup.component';
import { CommonDataSharingService } from '../../services/common-data-sharing.service';
import { BrowserStorageService } from '../../services/common/browser-storage.service';
import { UserService } from '../../services/user.service';
import { SafeHtmlPipe } from '../../validators/safe-html.pipe';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [DatePipe, CommonModule, RouterLink, NgOptimizedImage,SafeHtmlPipe],
})
export class FooterComponent implements OnInit {
  adminDetail: any;

  public userLoggedIn = false;
  date = new Date();
  storeUrl = environment.storeUrl;
  ICONS = ICONS;
  userInfo: any;
  constructor(
    private headerService: CommonDataSharingService,
    private _storageService: BrowserStorageService,
    private viewportScroller: ViewportScroller,
    private _ngbModal: NgbModal,
    private _userService: UserService,
    private _router: Router,
  ) {
    this._userService.user.subscribe((user) => {
      if (user) {
        this.userInfo = user;
      }
    });
    this.headerService.headerProfile.subscribe((shouldReload: any) => {
      if (shouldReload) {
        this.userInfo = _userService.getUserData();
      }
    });
  }

  ngOnInit(): void {
    this.adminDetail = this._storageService.getItem('userDetail');
    this._navigateToDashboard(this.adminDetail);
  }

  private _navigateToDashboard(accountToken: string): void {
    if (accountToken) {
      this.userLoggedIn = true;
    } else {
      this.userLoggedIn = false;
    }
  }

  taptotop() {
    this.viewportScroller.scrollToPosition([0, 0]);
  }
  onExploreClick(event: any, entity: any) {
    event.preventDefault();
    let modalRef = this._ngbModal.open(ViewStorePopupComponent, {
      scrollable: false,
      backdrop: 'static',
      keyboard: false,
      size: 'filterPopup',
      centered: true,
    });
    modalRef.componentInstance.entity = entity;
  }
}
